var Modernizr = require('modernizr');
var queryString = require('query-string');
var pagination = require('imports-loader?jQuery=jquery!../../js/libraries/jquery.simplePagination.js');
var exports = (module.exports = {});
var iCheck = require('icheck');
import {ShippingRate} from '../ShippingRate';

require('icheck/skins/square/square.css');

var s;
var OrderController = {
  settings: {},

  init: function() {
    var that = this;
    s = this.settings;
    if (window.totalElements) {
      that.initPagination();
    }

    //on init check first elements
    this.bindUIElements();
  },

  setDefaults: function() {
    $('.iCheck-billing')
      .first()
      .iCheck('check');
    $('.iCheck-delivery')
      .first()
      .iCheck('check');
  },

  bindUIElements: function() {
    var that = this;

    $('.iCheck-billing, .iCheck-delivery, .iCheck-insurance, .iCheck-bags').iCheck({
      checkboxClass: 'icheckbox_square',
      radioClass: 'iradio_square',
      increaseArea: '20%' // optional
    });

    $('.iCheck-billing')
      .on('ifClicked', function(ev) {
        $('.iCheck-billing').iCheck('uncheck');
        $('.billing-address').removeClass('address-active');
        $(ev.currentTarget).iCheck('check');
        $(ev.currentTarget)
          .closest('.billing-address')
          .addClass('address-active');
      })
      .on('ifChecked', function(ev) {
        $('#selected-billing').val(
          $(ev.currentTarget)
            .closest('.billing-address')
            .attr('data-id')
        );
      });

    $('.iCheck-delivery')
      .on('ifClicked', function(ev) {
        $('.iCheck-delivery').iCheck('uncheck');
        $('.delivery-address').removeClass('address-active');
        $(ev.currentTarget).iCheck('check');
        $(ev.currentTarget)
          .closest('.delivery-address')
          .addClass('address-active');
      })
      .on('ifChecked', function(ev) {
        $('#selected-delivery').val(
          $(ev.currentTarget)
            .closest('.delivery-address')
            .attr('data-id')
        );

        //ajax to calculate the shipping cost implemented here
        // that.getShippingRate();

        //trigger event
        var evt = new CustomEvent('triggerShippingCostCalculation');
        window.dispatchEvent(evt);
        // window.dispatchEvent(new CustomEvent("triggerShippingCostCalculation"));
      });

    $('.iCheck-insurance, .iCheck-bags').on('ifChanged', function(ev) {
      // $(ev.currentTarget).iCheck("check");
      var evt = new CustomEvent('calculateTotalOnCheckoutPage');
      window.dispatchEvent(evt);
    });

    this.setDefaults();
  },

  initPagination: function(pagenumber) {
    pagenumber = pagenumber ? pagenumber : queryString.parse(location.search).page * 1;

    $('.pagination-orders').pagination({
      items: window.totalElements,
      itemsOnPage: 10,
      currentPage: pagenumber ? pagenumber : 1,
      cssStyle: 'light-theme',
      hrefTextPrefix: '?page=',
      selectOnClick: false,
      nextText: '<i class="fa-right-open-big"></i>',
      prevText: '<i class="fa-left-open-big"></i>'
    });
  }

  // getDeliveryFormData: function () {
  //     // return $(".delivery-address.address-active")
  //     //     .find(".address-fields").serialize();
  //     return {
  //         delivery_id: $("#selected-delivery").val()
  //     };
  // },

  // getShippingRate: function () {

  //     var that = this;

  //     that.toggleLoadingOverlay("#loading-panel-checkout", "display");

  //     var request = $.ajax({
  //         url: "/checkout/shipping_rate",
  //         method: "GET",
  //         dataType: "json",
  //         data: that.getDeliveryFormData()
  //     });

  //     request.done(function (data) {

  //         //set shipping costs
  //         $("#shipping-cost").text(data.shipping_cost.NegotiatedRateCharges.MonetaryValue);
  //         $("#input_order_estimate_shipping").val(data.shipping_cost.NegotiatedRateCharges.MonetaryValue);

  //         //calculate total costs
  //         var order_total_wo_shipping = $("#order_estimate_wo_shipping").val();
  //         var order_total = parseFloat(data.shipping_cost.NegotiatedRateCharges.MonetaryValue * 1 + order_total_wo_shipping * 1).toFixed(2);
  //         $("#totalCosts").text(order_total);
  //         $("#order_total").val(order_total);

  //         //remove overlay
  //         that.toggleLoadingOverlay("#loading-panel-checkout", "hide");

  //         console.log(data);
  //     });

  //     request.fail(function (jqXHR, textStatus) {

  //         //remove overlay
  //         that.toggleLoadingOverlay("#loading-panel-checkout", "hide");
  //         console.log("Request failed: " + textStatus);
  //     });

  // },

  // toggleLoadingOverlay: function (element, action) {
  //     if (action == "hide") {
  //         $(element).fadeOut();
  //     } else {
  //         $(element).fadeIn();
  //     }

  //     return false;
  // }
};

module.exports = OrderController;



// WEBPACK FOOTER //
// ./public/src/js/pages/orderPage.js